module.exports = __webpack_public_path__ + "static/media/window-close-solid.c6e884f5.svg";